import React from 'react';

import { getCollectionById } from '../../../../../services';
import { Text } from '../../../../../shared/Typhography';

interface PropsCollectionColumn {
  id: string;
  onClick?: () => void;
  style?: any;
}

const CollectionColumn = ({ id, onClick, style }: PropsCollectionColumn) => {
  const { data } = getCollectionById(id);

  return (
    <Text style={style} onClick={onClick}>
      {data?.name}
    </Text>
  );
};

export default CollectionColumn;
